<!-- <div *ngIf="loader == true">
  <app-loader style="text-align: center"></app-loader>
</div> -->

<div class="container">
      <div class="row">
              <div class="col-3">
                  <h3>Order# {{ printData.orderNumber }}</h3>
              </div>
          </div>
          <hr>
          <div class="row">
              <div class="col">
                  <b>Date:</b> {{ printData.orderDate | date: "MM-dd-yyyy" }}<br>
                  <b>Time:</b> {{ printData.orderDate | date: "hh:mm:ss a" }}
              </div>
          </div>
          <div class="row">
            <div class="col">
                <b>Store Name:</b> {{ printData.retailerName }} <br>
                <b>Store Phone:</b> {{ printData.retailerPhone }}
            </div>
        </div>
          <div class="row">
              <div class="col">
                  <b>Sender:</b> {{ printData.senderName }} <br>
                  <b>Phone:</b> {{ printData.senderPhone }}
              </div>
          </div>
          <div class="row" *ngIf="printData.hasDeliverableItems==true">
              <div class="col">
                  <b>Receiver:</b> {{ printData.recieverName }} <br>
                  <b>Phone:</b> {{ printData.recieverPhone }}
              </div>
          </div>
          
          <hr>
          <div class="row" *ngFor="let obj of printData.orderItems">
              <div class="col">
                  <b>Product:</b> {{ obj.productDisplayText }} x {{ obj.quantity }} <br>
                  <b>Price:</b> ${{ obj.retailPrice }} <br>
                  <b>Total:</b> ${{ obj.totalRetailPrice }}
              </div>
          </div>
          <hr>
          <div class="row">
              <div class="col">
                  <b>Total Amount:</b> ${{ TotalOrderAmount }}
              </div>
          </div>
          <hr>
          <div class="row">
              <div class="col-3">
                  <p>THIS IS STORE COPY ONLY</p>
                  <p>For assistance call our toll-free number at 888-774-3542</p>
              </div>
          </div>
</div>



<!-- <div class="container mt-5" *ngIf="printData">
  <div class="row">
    <div class="col-lg-6">
      <h3 style="text-align: center">Order # {{ printData.orderNumber }}</h3>
    </div>
    <div class="col-lg-6"></div>
  </div>

  <div class="row mt-4">
    <div class="col-lg-6">
      <div class="row">
        <div class="col-lg-3">
          <b>Sender Name</b><br>
          <p>{{ printData.senderName }}</p>
          <b>Sender Number</b><br>
          <p>{{ printData.senderPhone }}</p>
          <b>Receiver Name</b><br><br>
          <p>{{ printData.recieverName }}</p>
          <b>Receiver Number</b><br />
          <p>{{ printData.recieverPhone }}</p>
        </div>

        <div class="col-lg-3">
         
        </div>
        <div class="col-lg-3">
          
        </div>
        <div class="col-lg-3">
          <b>Order Date</b><br />
          {{ printData.orderDate | date : "MM-dd-yyyy hh:mm:ss a" }}
            <br><br>
          <b>Retailer Name</b>
          <p>{{printData.retailerName}}</p><br>
          <b>Retailer Number</b>
          <p>{{printData.retailerPhone}}</p>
        </div>
      </div>
    </div>
   
  </div>

  <div class="row mt-4" *ngIf="printData.hasDeliverableItems == true">
    <div class="col-lg-6">
      <div class="row">
        <div class="col-lg-5">
          <h3>{{ printData.recieverName }}</h3>
          <p>{{ printData.recieverPhone }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-6">
      <table class="table table-bordered">
        <thead>
          <th>Product</th>
          <th>Quantity</th>
          <th>Price</th>
          <th>Total</th>
        </thead>
        <tbody>
          <tr *ngFor="let item of printData.orderItems">
            <td>{{ item.productDisplayText }}</td>
            <td>{{ item.quantity }}</td>
            <td>${{ item.retailPrice }}</td>
            <td>${{ item.totalRetailPrice }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-3"></div>
    <div class="col-3">
      <div class="row">
        <div class="col-6 center" style="border: 1px solid">
          <b>Total Order Amount</b>
        </div>
        <div class="col-6 center" style="border: 1px solid; text-align: center">
          ${{ TotalOrderAmount }}
        </div>
      </div>
    </div>
    <div class="col-6"></div>
  </div>
</div> -->
